import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EntityState } from '@ngrx/entity';
import {
  GUIDELINES_NOT_SAVED_CHANGES_FEATURE_KEY,
  GuidelinesNotSavedChangesEntity,
  guidelinesNotSavedChangesAdapter,
} from './guidelines-not-saved-changes.reducer';

const { selectEntities } = guidelinesNotSavedChangesAdapter.getSelectors();

const getGuidelinesNotSavedChangesFeatureState = createFeatureSelector<EntityState<GuidelinesNotSavedChangesEntity>>(
  GUIDELINES_NOT_SAVED_CHANGES_FEATURE_KEY
);
// eslint-disable-next-line
export const getGuidelinesNotSavedChangesEntities = () =>
  createSelector(getGuidelinesNotSavedChangesFeatureState, (state: EntityState<GuidelinesNotSavedChangesEntity>) =>
    selectEntities(state)
  );
